<template>
  <div class="page">
    <van-nav-bar
      title="实习申请"
      left-arrow
      @click-left="$router.go(-1)"
      z-index="99999"
      fixed
      :placeholder="true"
      :safe-area-inset-top="true"
    />
    <van-tabs
      type="line"
      v-model="active"
      animated
      color="#0088F8"
      @click="tabsChange"
    >
      <van-tab title="统一实习">
        <van-notice-bar
          color="#F85352"
          background="#fae6e5"
          left-icon="warning-o"
          >服从统一实习的学生无需进行“统一实习”申请</van-notice-bar
        >
        <div class="bblock">企事业单位信息</div>
        <van-form disabled>
          <van-field
            readonly
            v-model="tyForm.sxjdmc"
            name="实习基地"
            label="实习基地"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            readonly
            name="所属单位"
            :value="tyForm.sxqymc"
            input-align="right"
            error-message-align="right"
            label="所属单位"
          />
          <van-field
            readonly
            name="基地类别"
            :value="tyForm.sxjdlb"
            input-align="right"
            error-message-align="right"
            label="基地类别"
          />
          <van-field
            readonly
            name="基地负责人"
            :value="tyForm.qylxr"
            input-align="right"
            error-message-align="right"
            label="基地负责人"
          />
          <van-field
            readonly
            name="基地电话"
            :value="tyForm.lxrdh"
            input-align="right"
            error-message-align="right"
            label="基地电话"
          />
          <!-- <van-field v-model="tyForm.lxryx" name="联系人邮箱" label="联系人邮箱" input-align="right" error-message-align="right" /> -->
          <van-field
            v-model="tyForm.jddz"
            name="基地地址"
            label="基地地址"
            input-align="right"
            error-message-align="right"
          />
          <div class="bblock" v-if="schoolCode != '10422'">岗位信息</div>
          <van-field
          v-if="schoolCode != '10422'"
            v-model="tyForm.bmks"
            name="部门/科室"
            label="部门/科室"
            input-align="right"
            error-message-align="right"
          />
          <van-field
          v-if="schoolCode != '10422'"
            v-model="tyForm.gwmc"
            name="岗位名称"
            label="岗位名称"
            input-align="right"
            error-message-align="right"
          />
          <van-field
          v-if="schoolCode != '10422'"
            v-model="tyForm.qyls"
            name="企业老师"
            label="企业老师"
            input-align="right"
            error-message-align="right"
          />
          <van-field
          v-if="schoolCode != '10422'"
            v-model="tyForm.qylsdh"
            label-width="10em"
            name="企业老师电话"
            label="企业老师电话"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            readonly
            v-if="schoolCode != '10422'"
            name="岗位类别"
            :value="tyForm.gwlb"
            input-align="right"
            error-message-align="right"
            label="岗位类别"
          />
          <van-field
          v-if="schoolCode != '10422'"
            v-model="tyForm.gwjs"
            rows="1"
            autosize
            label="岗位介绍"
            input-align="right"
            type="textarea"
          />
          <van-field
          v-if="schoolCode != '10422'"
            v-model="tyForm.gznr"
            rows="1"
            autosize
            label="工作内容"
            input-align="right"
            type="textarea"
          />

          <div class="bblock">实习信息</div>
          <van-field
            v-model="tyForm.xm"
            label-width="10em"
            name="校内指导教师"
            label="校内指导教师"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            readonly
            name="calendar"
            :value="tyForm.kssj"
            label="开始时间"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            readonly
            name="结束时间"
            :value="tyForm.jssj"
            label="结束时间"
            input-align="right"
            error-message-align="right"
          />
          <van-field
            readonly
            name="专业对口"
            :value="tyForm.zydk == 1 ? '是' : '否'"
            label="专业对口"
            input-align="right"
            error-message-align="right"
          />
        </van-form>
      </van-tab>
      <van-tab title="分散实习">
        <div class="bblock">企事业单位信息</div>
        <van-form @submit="onSubmit">
          <van-field
            v-model="fsForm.qymctext"
            autocomplete="off"
            required
            name="企业名称"
            label="企业名称"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写企业名称' }]"
          />
          <van-field
            @input="showTogle"
            v-model="fsForm.qymc"
            autocomplete="off"
            required
            :name="schoolCode == '13772' ? '打卡定位地点名称' :'打卡企业'"
            :label="schoolCode == '13772' ? '打卡定位地点名称' :'打卡企业' "
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ required: true, message: schoolCode == '13772' ? '请填写打卡定位地点名称' :'请填写打卡企业' }]"
          />
          <van-dropdown-menu>
            <van-dropdown-item
              @change="valueChange"
              ref="option"
              v-model="value1"
              :options="option"
              get-container="body"
            />
          </van-dropdown-menu>
          <van-field
            v-if="schoolCode != '10848' && schoolCode != '14475' && schoolCode != '13772' "
            label-width="8em"
            v-model="fsForm.tyshxydm"
            name="统一社会信用代码"
            label="统一社会信用代码"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            @input="xydmlengthjy"
          />
          <van-field
            v-else
            label-width="8em"
            required
            v-model="fsForm.tyshxydm"
            name="统一社会信用代码"
            label="统一社会信用代码"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            @input="xydmlengthjy"
            :rules="[{ required: true, message: '请填写统一社会信用代码' }]"
          />
          <van-field
            v-if="schoolCode == '10848' || schoolCode == '14475' || schoolCode == '13772' "
            label-width="8em"
            required
            v-model="fsForm.sxyy"
            name="元/月"
            label="元/月"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            @input="yyjy"
            :rules="[{ required: true, message: '请填写元/月' }]"
          />
          <van-field
            readonly
            clickable
            required
            name="企业性质"
            :value="pickerData1"
            input-align="right"
            is-link
            error-message-align="right"
            label="企业性质"
            placeholder="请选择"
            @click="showPicker1 = true"
            :rules="[{ required: true, message: '请填写企业性质' }]"
          />
          <van-field
            readonly
            clickable
            required
            name="行业性质"
            :value="pickerData2"
            input-align="right"
            is-link
            error-message-align="right"
            label="行业性质"
            placeholder="请选择"
            @click="showPicker2 = true"
            :rules="[{ required: true, message: '请选择行业性质' }]"
          />
          <van-field
            readonly
            clickable
            required
            name="所属行业"
            :value="pickerData3"
            input-align="right"
            is-link
            error-message-align="right"
            label="所属行业"
            placeholder="请选择"
            @click="showPicker3 = true"
            :rules="[{ required: true, message: '请选择所属行业' }]"
          />
          <van-field
            readonly
            clickable
            required
            name="所在城市"
            :value="area"
            input-align="right"
            is-link
            error-message-align="right"
            label="所在城市"
            placeholder="请选择"
            @click="showArea = true"
            :rules="[{ required: true, message: '请选择所在城市' }]"
          />
          <van-field
            v-model="fsForm.xxdz"
            :disabled="xxdzsfxg == '1'"
            required
            rows="1"
            autosize
            label="详细地址"
            input-align="right"
            type="textarea"
            placeholder="请输入"
          />
          <van-field
            readonly
            clickable
            is-link
            :value="pickerData5"
            @click="showPicker7 = true"
            required
            name="企业人数规模"
            label="企业人数规模"
            input-align="right"
            error-message-align="right"
            placeholder="请选择"
            :rules="[{ required: true, message: '请选择企业人数规模' }]"
          />
          <van-field
            v-model="fsForm.qylxr"
            name="企业联系人"
            label="企业联系人"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
          />
          <van-field
            v-model="fsForm.lxrdh"
            name="基地电话"
            label="基地电话"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
          />
          <van-field
            v-model="fsForm.lxryx"
            name="联系人邮箱"
            label="联系人邮箱"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
          />

          <div class="bblock" v-if="schoolCode != '10422'">岗位信息</div>
          <van-field
            v-if="schoolCode != '10422'"
            v-model="fsForm.bm"
            required
            name="部门科室"
            label="部门科室"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写部门科室' }]"
          />
          <van-field
            v-if="schoolCode != '10422' "
            v-model="fsForm.gwmc"
            required
            name="岗位名称"
            label="岗位名称"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写岗位名称' }]"
          />
          <van-field
            v-if="schoolCode != '10422' "
            v-model="fsForm.xwzdjs"
            required
            name="企业老师"
            label="企业老师"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写企业老师' }]"
          />
          <van-field
            v-if="schoolCode != '10422'"
            v-model="fsForm.xwzdjslxfs"
            required
            label-width="10em"
            name="企业老师电话"
            label="企业老师电话"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ pattern: phone, message: '请填写企业老师电话' }]"
          />
          <van-field
            readonly
            clickable
            :required="schoolCode != '13772'"
            v-if="schoolCode != '10422'"
            name="岗位类别"
            :value="pickerData4"
            input-align="right"
            is-link
            error-message-align="right"
            label="岗位类别"
            placeholder="请选择"
            @click="showPicker4 = true"
            :rules="[{ required: schoolCode != '13772' ? true : false, message: '请选择岗位类别' }]"
          />
          <van-field
            v-if="schoolCode != '10422'"
            v-model="fsForm.gwjs"
            rows="1"
            autosize
            label="岗位介绍"
            input-align="right"
            type="textarea"
            placeholder="请输入"
          />
          <van-field
          v-if="schoolCode != '10422'"
            v-model="fsForm.gznr"
            rows="1"
            autosize
            label="工作内容"
            input-align="right"
            type="textarea"
            placeholder="请输入"
          />

          <van-field
            v-if="schoolCode == '14475'"
            v-model="fsForm.sjhm"
            rows="1"
            autosize
            label="手机号码"
            input-align="right"
            type="tel"
            placeholder="请输入"
            required
            error-message-align="right"
            :rules="[{ required: true, message: '请输入手机号码' }]"
            maxlength="11"
          />

          <van-field
            class="zdylabel"
            v-if="schoolCode == '14475'"
            v-model="fsForm.sxts"
            rows="1"
            autosize
            label="实习天数(天/周)"
            input-align="right"
            type="number"
            placeholder="请输入"
            required
            error-message-align="right"
            :rules="[{ required: true, message: '请输入实习天数' }]"
          />

          <van-field
            class="zdylabel"
            v-if="schoolCode == '14475'"
            v-model="fsForm.sxsc"
            rows="1"
            autosize
            label="实习时长(小时/天)"
            input-align="right"
            type="number"
            placeholder="请输入"
            required
            error-message-align="right"
            :rules="[{ required: true, message: '请输入实习时长' }]"
          />

          <van-field
            class="zdylabel"
            v-if="schoolCode == '14475'"
            v-model="fsForm.sxbc"
            rows="1"
            autosize
            label="实习报酬(元/月)"
            input-align="right"
            type="number"
            placeholder="请输入"
            required
            maxlength="8"
            error-message-align="right"
            :rules="[{ required: true, message: '请输入实习报酬' }]"
          />

          <div class="bblock">实习信息</div>
          <van-field
            v-model="fsForm.xnzdjs"
            :disabled="xnzdjsdis == '1'"
            clickable
            required
            readonly
            @click="xnzdjsdis == '0' ? showPicker6 = true : showPicker6 = false"
            label-width="10em"
            is-link
            name="校内指导教师"
            label="校内指导教师"
            input-align="right"
            error-message-align="right"
            placeholder="请输入"
            :rules="[{ required: true, message: '请填写校内指导教师' }]"
          />
          <van-field
            readonly
            clickable
            required
            name="calendar"
            :value="fsForm.kssj"
            label="开始时间"
            input-align="right"
            is-link
            error-message-align="right"
            placeholder="请选择"
            :disabled="sxjhsjsfxg == '1'"
            @click="sxjhsjsfxg == '0' ? showCalendar = true : showCalendar = false"
            :rules="[{ required: true, message: '请选择开始时间' }]"
          />
          <van-field
            readonly
            clickable
            required
            name="结束时间"
            :value="fsForm.jssj"
            label="结束时间"
            input-align="right"
            is-link
            error-message-align="right"
            placeholder="请选择"
            :disabled="sxjhsjsfxg == '1'"
            @click="sxjhsjsfxg == '0' ? showEndCalendar = true : showEndCalendar = false"
            :rules="[{ required: true, message: '请选择结束时间' }]"
          />
          <van-field
            name="专业对口"
            required
            label="专业对口"
            :rules="[{ required: true, message: '请选择专业对口' }]"
          >
            <template #input>
              <van-radio-group
                icon="activeIcon"
                v-model="fsForm.zydk"
                :disabled="zydkdis == '1'"
                direction="horizontal"
              >
                <van-radio name="1"
                  >是
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activeIcon : inactiveIcon"
                    />
                  </template>
                </van-radio>
                <van-radio name="0"
                  >否
                  <template #icon="props">
                    <img
                      class="img-icon"
                      :src="props.checked ? activeIcon : inactiveIcon"
                    />
                  </template>
                </van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field
            name="uploader"
            
            :label="schoolCode == '13772' ? '用人单位录用函' :'上传附件' "
          >
            <template #input>
              <van-uploader
                accept="image/*"
                :max-size="5 * 1024 * 1024"
                @oversize="$toast('文件大小不能超过 5M ')"
                :max-count="1"
                :after-read="upload"
                v-model="fileList"
              />
            </template>
          </van-field>
          <div class="button-box">
            <van-button
              round
              type="default"
              native-type="button"
              @click="saveInfo"
              >暂存</van-button
            >
            <van-button round type="info" native-type="submit">提交</van-button>
          </div>
        </van-form>
      </van-tab>
    </van-tabs>
    <!-- 企业性质 -->
    <van-popup v-model="showPicker1" round position="bottom">
      <van-picker
        show-toolbar
        :columns="preData[0].list"
        @cancel="showPicker1 = false"
        @confirm="onConfirm1"
      />
    </van-popup>
    <!-- 行业类别 -->
    <van-popup v-model="showPicker2" round position="bottom">
      <van-picker
        show-toolbar
        :columns="preData[1].list"
        @cancel="showPicker2 = false"
        @confirm="onConfirm2"
      />
    </van-popup>

    <!-- 所属行业 -->
    <van-popup v-model="showPicker3" round position="bottom">
      <van-picker
        show-toolbar
        :columns="preData[2].list"
        @cancel="showPicker3 = false"
        @confirm="onConfirm3"
      /> </van-popup
    >·
    <!-- 岗位类别 -->
    <van-popup v-model="showPicker4" round position="bottom">
      <van-picker
        show-toolbar
        :columns="preData[3].list"
        @cancel="showPicker4 = false"
        @confirm="onConfirm4"
      />
    </van-popup>
    <!-- 选择开始时间 -->
    <van-popup v-model="showCalendar" round position="bottom">
      <van-datetime-picker
        :min-date="new Date(timeRange[0])"
        :max-date="new Date(timeRange[1])"
        @cancel="showCalendar = false"
        type="date"
        title="选择开始时间"
        @confirm="onConfirm5"
      />
    </van-popup>
    <!-- 选择开始时间 -->
    <van-popup v-model="showEndCalendar" round position="bottom">
      <van-datetime-picker
        type="date"
        :min-date="new Date(timeRange[0])"
        title="选择结束时间"
        @cancel="showEndCalendar = false"
        @confirm="onConfirm6"
      />
    </van-popup>
    <!-- 选择城市 -->
    <van-popup v-model="showArea" round position="bottom">
      <van-cascader
        v-model="fsForm.cs"
        title="请选择所在城市"
        :options="areaList"
        @close="showArea = false"
        @finish="onFinish"
      />
    </van-popup>
    <!-- 选择审批人 -->
    <van-popup v-model="showPicker5" round position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="showPicker5 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="saveData()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            @click="personTap($event, index)"
            v-for="(item, index) in userList"
            :key="item.userid"
          >
            {{ item.userrealname }}
          </button>
        </div>
      </div>
    </van-popup>
    <!-- 校内指导教师 -->
    <van-popup v-model="showPicker6" round position="bottom">
      <van-picker
        show-toolbar
        :columns="preData[4].list"
        @cancel="showPicker6 = false"
        @confirm="onConfirm7"
      />
    </van-popup>
    <!-- 企业规模人数 -->
    <van-popup v-model="showPicker7" round position="bottom">
      <van-picker
        show-toolbar
        :columns="preData[6].list"
        @cancel="showPicker7 = false"
        @confirm="onConfirm8"
      />
    </van-popup>
  </div>
</template>

<script>
import iApi from "@/utils/internship";
import { mapGetters } from "vuex";
import { Toast } from "vant";
import Axios from "axios";
export default {
  data() {
    return {
      schoolCode:'',
      isEdit: false,
      activeIcon: require("../../../../../static/img/dxIcon.png"),
      inactiveIcon: require("../../../../../static/img/dxWxz.png"),
      active: 0,
      value: "",
      phone: /^1[3456789]\d{9}$/,
      email: /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,5}$/,
      showCalendar: false,
      showEndCalendar: false,
      showArea: false,
      areaList: {},
      showPicker1: false,
      pickerData1: "",
      showPicker2: false,
      pickerData2: "",
      showPicker3: false,
      pickerData3: "",
      pickerData5: "",
      showPicker4: false,
      showPicker5: false,
      showPicker6: false,
      showPicker7: false,
      sxjhsjsfxg:'',
      xxdzsfxg:'',
      userList: [
        {
          useraccount: "",
          useremail: "",
          userid: "",
          userrealname: "全部",
          isBtn: 0
        }
      ],
      pickerData4: "",
      area: "",
      fileList: [],
      preData: [
        { title: "", list: [] },
        { title: "", list: [] },
        { title: "", list: [] },
        { title: "", list: [] },
        { title: "", list: [] },
        { title: "", list: [] },
        { title: "", list: [] }
      ],
      tyForm: {
        sxjdmc: "",
        sxqymc: "",
        sxjdlb: "",
        qylxr: "",
        qylsdh: "",
        lxryx: "",
        jddz: "",
        gwmc: "",
        qyls: "",
        lxrdh: "",
        gwlb: "",
        gwjs: "",
        gznr: "",
        xm: "",
        kssj: "",
        jssj: "",
        zydk: "",
        bmks: ""
      },
      fsForm: {
        qymctext: "",
        qymc: "",
        tyshxydm: "",
        qyxz: "",
        hylb: "",
        sshy: "",
        sf: "",
        cs: "",
        xxdz: "",
        qyrsgm: "",
        qylxr: "",
        lxrdh: "",
        lxryx: "",
        bm: "",
        gwmc: "",
        xwzdjs: "",
        xwzdjslxfs: "",
        gwlb: "",
        gwjs: "",
        gznr: "",
        xnzdjs: "",
        kssj: "",
        jssj: "",
        zydk: "",
        file: "",
        xnzdjsjgh: "",
        sxjhid: "",
        userid: "",
        type: "add",
        sxsqshid: "",
        ddjd: "",
        ddwd: "",
        sxyy:"",
        sjhm:"",
        sxts:"",
        sxsc:"",
        sxbc:"",
      },
      value1: "",
      option: [],
      xnzdjsdis:"",
      zydkdis:""
    };
  },
  computed: {
    ...mapGetters({
      sxjhid: "getSxjhid",
      isty: "getIsty",
      timeRange: "getTimeRange"
    })
  },
  methods: {
    // 表单验证函数 - 在输入结束后调用
    checkInput(){
      var sjhm = this.fsForm.sjhm
      if(sjhm=="" || sjhm==undefined || sjhm=="undefined"){
        this.$toast("请输入手机号码");
        return false;
      }
      else if(!this.phone.test(sjhm)){
        this.$toast("请输入正确的11位手机号码");
        this.fsForm.sjhm="";
        return false;
      }

      var sxts = this.fsForm.sxts
      if(sxts=="" || sxts==undefined || sxts=="undefined"){
        this.$toast("请输入实习天数");
        return false;
      }
      else {
        var decimalRegex = /^(0|[1-9]\d*)(\.\d{1,2})?$/
        if(!decimalRegex.test(String(sxts))){
          this.$toast('实习天数请输入数字或最多2位小数');
          this.fsForm.sxts="";
          return false;
        }
        else {
          var numValue = parseFloat(sxts)
          // 验证数值范围
          if(numValue <= 0 || numValue > 5){
            this.$toast('实习天数请输入大于0且小于等于5的数值');
            this.fsForm.sxts="";
            return false;
          }
        }
      }

      var sxsc = this.fsForm.sxsc
      if(sxsc=="" || sxsc==undefined || sxsc=="undefined"){
        this.$toast("请输入实习时长");
        return false;
      }
      else {
        var decimalRegex = /^(0|[1-9]\d*)(\.\d{1,2})?$/
        if(!decimalRegex.test(String(sxsc))){
          this.$toast('实习时长请输入数字或最多2位小数');
          this.fsForm.sxsc="";
          return false;
        }
        else {
          var numValue = parseFloat(sxsc)
          // 验证数值范围
          if(numValue <= 0 || numValue > 8){
            this.$toast('实习时长请输入大于0且小于等于8的数值');
            this.fsForm.sxsc="";
            return false;
          }
        }
      }

      var sxbc = this.fsForm.sxbc
      if(sxbc=="" || sxbc==undefined || sxbc=="undefined"){
        this.$toast("请输入实习报酬");
        return false;
      }
      else {
        var decimalRegex = /^(0|[1-9]\d*)(\.\d{1,2})?$/
        if(!decimalRegex.test(String(sxbc))){
          this.$toast('实习报酬请输入数字或最多2位小数');
          this.fsForm.sxbc="";
          return false;
        }
        else {
          var numValue = parseFloat(sxbc)
          // 验证数值范围
          if(numValue < 0){
            this.$toast('实习报酬请输入非负数');
            this.fsForm.sxbc="";
            return false;
          }
        }
      }

      return true;
    },
    async showTogle(e) {
      Axios({
        method: "get",
        url: "https://restapi.amap.com/v3/place/text",
        params: {
          // 这个key是无锡职业学院自己申请的(花钱了的)，其他学校不要用
          key: window.__config__.VUE_AMPP_KEY_SEARCHER,
          keywords: e
        }
      }).then(res => {
        if (res.data.pois.length > 0) {
          this.option = res.data.pois.map(item => {
            return {
              text: item.name,
              value: item.id,
              location: item.location,
              address: item.pname + item.cityname + item.adname + item.address,
            };
          });
          this.$refs.option.toggle(true);
        } else {
          this.$refs.option.toggle(true);
        }
      });
    },
    async valueChange(e) {
      let index = this.option.findIndex(item => item.value == e);
      let arr = this.option.filter(item => item.value == e);
      if (index != -1) {
        this.fsForm.xxdz = arr[0].address;
        this.fsForm.qymc = arr[0].text;
        if (arr[0].location.split(',').length = 2){
          this.fsForm.ddjd = arr[0].location.split(',')[0];
          this.fsForm.ddwd = arr[0].location.split(',')[1];
        }
        // console.log(this.fsForm);

        // this.fsForm.qymc = this.option[index].text;
        // const res = await iApi.getQyDetail({
        //   sxqyid: e
        // });
        // this.fsForm.tyshxydm = res.data.tyshxydm;
        // this.fsForm.lxrdh = res.data.lxrdh;
        // this.fsForm.lxryx = res.data.lxryx;
        // this.fsForm.qylxr = res.data.qylxr;
        // this.fsForm.cs = res.data.qysscs;
        // this.fsForm.sf = res.data.qysssf;
        // this.fsForm.qyxz = res.data.qyxz;
        // this.fsForm.hylb = res.data.hylb;
        // this.fsForm.sshy = res.data.qysshy;
        // this.pickerData1 = res.data.qyxzmc;
        // this.pickerData2 = res.data.hylbmc;
        // this.pickerData3 = res.data.sshymc;
        // this.area = res.data.qysscsmc;
        // this.fsForm.qyrsgm = res.data.qygmrs;
        // this.pickerData5 = res.data.qygmrsmc;
      }
    },
    xydmlengthjy(e){
      var reg = new RegExp("^[a-zA-Z0-9]+$");
			if(!reg.test(e)){
				this.$toast.fail("只能输入数字和字母！");
				this.fsForm.tyshxydm = "";
				return ;
			}
      if (e.length > 18){
        this.fsForm.tyshxydm = e.substring(0,18);
      }
    },
    yyjy(e){
      if (e== null || e== 0 || e>9999){
        this.$toast.fail('元/月不能为0或大于9999!');
        this.fsForm.sxyy = '';
      }
    },
    onConfirm1(data) {
      console.log(data);
      this.fsForm.qyxz = data.id;
      this.pickerData1 = data.text;
      this.showPicker1 = false;
    },
    onConfirm2(data) {
      console.log(data);
      this.fsForm.hylb = data.id;
      this.pickerData2 = data.text;
      this.showPicker2 = false;
    },
    onConfirm3(data) {
      console.log(data);
      this.fsForm.sshy = data.id;
      this.pickerData3 = data.text;
      this.showPicker3 = false;
    },
    onConfirm4(data) {
      console.log(data);
      this.fsForm.gwlb = data.id;
      this.pickerData4 = data.text;
      this.showPicker4 = false;
    },
    onConfirm5(data) {
      console.log(data);
      this.fsForm.kssj = new Date(data).format("yyyy-MM-dd");
      this.showCalendar = false;
    },
    onConfirm6(data) {
      console.log(data);
      this.fsForm.jssj = new Date(data).format("yyyy-MM-dd");
      this.showEndCalendar = false;
    },
    onConfirm7(data) {
      console.log(data);
      this.fsForm.xnzdjsjgh = data.id;
      this.fsForm.xnzdjs = data.text;
      this.showPicker6 = false;
    },
    onConfirm8(data) {
      console.log(data);
      // this.fsForm.xnzdjsjgh = data.id
      // this.fsForm.xnzdjs = data.text
      this.fsForm.qyrsgm = data.id;
      this.pickerData5 = data.text;
      this.showPicker7 = false;
    },
    personTap(e, res) {
      console.log(e, res);
      let strList = [];
      let idList = [];
      if (this.userList[res].isBtn == 0) {
        this.userList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.userList[res].isBtn == 1) {
        this.userList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.userList) {
        // if (this.userList[res].userrealname == "全部") {
        //   this.userList[i].isBtn = 0;
        //   this.userList[res].isBtn = 1;
        //   this.$refs.person[res].className = "cur";
        //   this.$refs.person[i].className = "per-btn";
        // } else {
        //   this.userList[0].isBtn = 0;
        //   this.$refs.person[0].className = "per-btn";
        // }
        if (this.userList[i].isBtn == 1) {
          strList = strList.concat(this.userList[i].userrealname);
          idList = idList.concat(this.userList[i].userid);
        }
      }
      this.fsForm.userid = idList.toString();
    },
    onFinish({ selectedOptions }) {
      this.showArea = false;
      this.fsForm.cs = selectedOptions[1].value;
      this.fsForm.sf = selectedOptions[0].value;
      this.area = selectedOptions[1].text;
    },
    async upload(e) {
      console.log(e);
      this.fsForm.file = e.file;
    },

    tabsChange(name, title) {
      if (title == "分散实习" && this.preData[0].type != "") {
      }
    },
    // 获取统一实习详细数据
    async getApplyDetails() {
      // 当且仅当为统一实习才申请
      if (this.isty == 1) {
        const res = await iApi.getApplyDetail({ sxjhid: this.sxjhid });
        this.tyForm = res.data;
      }
    },
    // 获取各种下拉框数据和预置数据
    async getPreData() {
      const res = await iApi.getPreInfoList({
        sxjhid: this.sxjhid
      });
      this.preData = res.data;
      if (res.data[4].jgMap.length > 0){
          this.fsForm.xnzdjs = res.data[4].jgMap[0].text;
          this.fsForm.xnzdjsjgh = res.data[4].jgMap[0].id;
        }
      this.fsForm.sxjhid = this.sxjhid;
      //开始时间结束时间默认值
      if (res.data[8].list.length > 0){
          this.fsForm.kssj =  res.data[8].list[0].sxkssj;
          this.fsForm.jssj =  res.data[8].list[0].sxjssj;
        }
        if (res.data[9].list != null && res.data[9].list.length > 0){
          this.sxjhsjsfxg = res.data[9].list[0].sxjhsjsfxg;
          this.xxdzsfxg = res.data[9].list[0].xxdzsfxg;
        }
        this.fsForm.zydk = "1";
        if(this.schoolCode == '10848' || this.schoolCode == '14475'){
          //修改不可更改状态
          this.xxdzsfxg = '1';
          this.xnzdjsdis = '1';
          this.zydkdis = '1';
          this.sxjhsjsfxg = '1';
          this.sxjhsjsfxg = '1';
        }
      // 获取所有省市列表
      // if (!localStorage.getItem("areaList")) {
        const provinces = await iApi.getAreaList();
        this.areaList = provinces.data;
      //   localStorage.setItem("areaList", JSON.stringify(this.areaList));
      // } else {
      //   this.areaList = JSON.parse(localStorage.getItem("areaList"));
      // }
    },
    // 暂存信息
    saveInfo() {
      let data = {
        form: this.fsForm,
        pickerData1: this.pickerData1,
        pickerData2: this.pickerData2,
        pickerData3: this.pickerData3,
        pickerData4: this.pickerData4,
        pickerData5: this.pickerData5,
        area: this.area,
        fileList: this.fileList
      };
      data = JSON.stringify(data);
      localStorage.setItem(this.sxjhid, data);
      this.$toast.success("暂存成功！");
    },
    // 获取本地缓存或者编辑获取远程数据
    async getInfo() {
      // 非编辑模式下获取本地数据
      if (!this.isEdit) {
        let tempData = localStorage.getItem(this.sxjhid);
        if (tempData) {
          let data = JSON.parse(tempData);
          this.fsForm = data.form;
          this.pickerData1 = data.pickerData1;
          this.pickerData2 = data.pickerData2;
          this.pickerData3 = data.pickerData3;
          this.pickerData4 = data.pickerData4;
          this.pickerData5 = data.pickerData5;
          this.area = data.area;
          this.fileList = data.fileList;
        }
      } else {
        // 编辑模式下获取远程数据
        const res = await iApi.getReapplyInfo({ sxjhid: this.sxjhid });
        let list = Object.keys(this.fsForm);
        list.forEach(item => {
          if (res.data.xq[item]) {
            this.fsForm[item] = res.data.xq[item];
          }
          console.log(item+":"+this.fsForm[item])
        });
        this.fsForm.type = "edit";
        this.pickerData1 = res.data.mc.qyxz;
        this.pickerData2 = res.data.mc.hylb;
        this.pickerData3 = res.data.mc.sshy;
        this.pickerData4 = res.data.mc.gwlb;
        this.pickerData5 = res.data.mc.qygmrsmc;
        this.area = res.data.mc.cs;
        this.fileList.push({
          content: res.data.mc.base64
        });
      }
    },
    // 提交申请
    async onSubmit() {
      if(this.schoolCode=="14475" && !this.checkInput()){
        return false
      }
      // 判断是否是统一申请，如果是直接提示不让提交
      // if (this.isty == 1) {
      //   Toast('当前计划为统一实习，无法申请分散实习')
      //   return
      // }
      // 弹出审批人弹窗
      this.userList = [];
      const res = await iApi.getReviewer({ ywcode: 667 });
      this.showPicker5 = true;
      this.userList = this.userList.concat(res.data);
      this.userList.forEach((item, index) => {
        this.userList[index].isBtn = 0;
      });
    },
    async saveData() {
      this.showPicker5 = false;
      if(this.fsForm.userid == null || this.fsForm.userid == ''){
        this.$toast.fail("请选择审核人!");
        return null;
      }

      // 初次提交
      if (!this.isEdit) {
        const res = await iApi.setApplyInfo(this.fsForm);
        // 清除本地缓存
        localStorage.removeItem(this.sxjhid);
        if (res.code == 1) {
          this.$toast.success("提交申请成功");
          setTimeout(() => {
            this.$router.replace({
              path: "/internship/applyStatus?config=1"
            });
          }, 800);
        }
      } else {
        const res = await iApi.setApplyInfo(this.fsForm);
        if (res.code == 1) {
          this.$toast.success("重新申请成功");
          setTimeout(() => {
            this.$router.go(-1);
          }, 800);
        }
        // 清除本地缓存
        localStorage.removeItem(this.sxjhid);
      }
    }
  },
  created() {
    this.schoolCode = sessionStorage.getItem("schoolCode");
    // 获取统一实习信息
    this.getApplyDetails();
    // 获取预置数据
    this.getPreData();
    if (this.$route.query.isEdit) {
      this.isEdit = true;
      this.active = 1;
    }
    // 获取信息
    this.getInfo();
  }
};
</script>

<style lang="less" scoped>
.img-icon {
  height: 20px;
}
.van-tabs__line {
  background-color: #0088f8 !important;
  width: 25px;
}
.van-tab--active {
  color: #333333 !important;
  font-weight: 600 !important;
}
.page {
  min-height: 100vh;
  background: #f2f2f4;
  margin-top: -50px;
  .bblock {
    height: 40px;
    background: #f2f2f4;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    letter-spacing: 0;
    margin-left: 15px;
    line-height: 50px;
  }
}
.van-field__label {
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 16px !important;
  span {
    color: #333333 !important;
  }
}
.button-box {
  width: 100%;
  height: 70px;
  background: #ffffff;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.van-button {
  width: 165px;
  height: 50px;
  border: 1px solid #e5e5e5;
  border-radius: 25px !important;
}
.apply-pop {
  width: 100%;
  position: fixed;
  bottom: 0;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  max-height: 40%;
  overflow-y: scroll;
}
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.pop-title {
  display: flex;
  justify-content: space-between;
  padding: 13px;
  position: fixed;
  width: 100%;
  background-color: @attendance-color-3;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
  z-index: 9;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.person {
  padding: 20px 20px 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: 48px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 15px;
}
.apply-pop .person .per-btn {
  background-color: @attendance-background-color-7;
  color: @attendance-background-color-1;
}
.person .cur {
  background-color: @attendance-background-color-1;
  color: @attendance-background-color-7;
}
/deep/.van-dropdown-menu__bar {
  height: 0 !important;
  opacity: 0 !important;
}
.zdylabel /deep/ .van-field__label{
  width: 165px!important;
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/internship/applyFor.vue